<script>
  export default {
    name: 'PromoPackPopup',

    computed: {
      isAnyGameOpen() {
        return this.$store.state.dialog.iframeDialog !== null;
      },

      showDialog() {
        return this.$store.state.dialog.showPromoPackPopup;
      },

      promoPack() {
        return this.$store.getters.getActivePromoPack;
      },

      bannerImage() {
        if (!this.showDialog) return '';

        const { price, mmcAmount } = this.promoPack;
        //return `/images/banners/promo-login_Price-${price}_MC-${mmcAmount}_QC-${mqcAmount}.webp?v=3`;
        return `/images/banners/MQ-pop-up-promo_price-${price}_MC-${mmcAmount}.webp?v=2`;
      },
    },

    watch: {
      isAnyGameOpen: {
        immediate: true,
        handler(value) {
          if (!value) return;
          this.closeDialog();
        },
      },
    },

    methods: {
      closeDialog() {
        this.$emit('close');
        this.$store.commit('SET_SHOW_PROMO_PACK_POPUP', false);
      },

      handleBannerClick() {
        this.$store.dispatch('setWalletDialog', {
          value: true,
          tab: 'purchase',
          balanceField: null,
          filterPacks: [this.promoPack],
        });
        this.closeDialog();
      },

      handleImageError() {
        console.error(`PromoPack Popup error - image not found: ${this.bannerImage}`);
        this.closeDialog();
      },
    },
  };
</script>

<template>
  <v-dialog
    v-if="showDialog"
    v-model="showDialog"
    content-class="promo-pack-popup"
    :max-width="460"
    class="blurred"
    @click:outside="closeDialog"
    @keydown.esc="closeDialog"
  >
    <div class="position-relative">
      <v-img
        :src="bannerImage"
        alt="promotional package"
        class="banner"
        @click="handleBannerClick"
        @error="handleImageError"
      />
    </div>
  </v-dialog>
</template>

<style lang="scss" scoped>
  .v-icon {
    position: absolute;
    right: 10px;
    top: 10px;
  }

  .icon {
    position: absolute;
    z-index: 1;
  }

  .banner {
    max-width: 460px;
    cursor: pointer;
    background-size: contain;
  }
</style>

<style lang="scss">
  .promo-pack-popup {
    box-shadow: none;
  }
</style>
